const $ = jQuery.noConflict();

'use strict';
const EloaSendMail = {

	/*-------------------------------------------------------------------------------
	# Initialize
-------------------------------------------------------------------------------*/
	init: function() {
		this.sendMail();
	},

	sendMail: function() {
		const text = $('div:hidden.hidden-div').text();
		if (text) {
			$('input.wpcf7-form-control.wpcf7-hidden.hidden-repeater').attr('value', text);
		}
		$('#sig-submitBtn').click(() => {
			const sigCanvas = $('#sig-image').attr('src');
			$('input.wpcf7-form-control.wpcf7-hidden.signature-url').attr('value', sigCanvas);
		});
		$('.js-eloa-submit').click(() => {
			$('.upload-file-txt').text('No file chosen');
		});
	},
};

export default EloaSendMail;
